'use strict';

const $ = require('jquery');

class Form {

    constructor() {

        this.renderForm();
        this.initFilterAutoFocus();

        App.Globals.$document
            .on('gform_post_render', () => {

                this.renderForm();

            })
            .on('gform_confirmation_loaded', (event, formId) => {

                this.renderSuccess(event, formId);

            });

    }

    initFilterAutoFocus() {
        // Get input with data-filter-focus attribute
        let $filterInput = $('[data-filter-focus]');

        // Get a query param with the same name as $filterInput
        let queryParam = new URLSearchParams(window.location.search).get($filterInput.data('filter-focus'));

        if ($filterInput.length === 1 && queryParam) {
            $filterInput.trigger('focus');
        }
    }

    toggleLabel() {

        this.$labels
            .removeClass('selected')
            .filter(':has(:checked)')
            .addClass('selected');

    }

    renderSuccess(event, formId) {

        //  Success handler

    }

    renderForm() {

        //  Remove all tabindexes to avoid switching between forms
        $('input, select, textarea, button, .gform_anchor').removeAttr('tabindex');
        setTimeout(function(){ $('.ginput_recaptcha iframe').removeAttr('tabindex'); }, 500);

        //  Custom checkboxes and radio's
        let $choiceBoxes = $('.gfield_radio li, .gfield_checkbox li');

        $choiceBoxes.closest('.gfield').addClass('checkbox-radio-field');

        if ($choiceBoxes.length > 0) {

            $choiceBoxes.each(function () {

                let $this = $(this);
                let oldInput = $this.find('input');
                let className = $this.parent().attr('class').replace('gfield_', '');

                let $label = $this.find('label');

                if ($label.length > 0) {

                    $label.addClass(className).prepend(oldInput);

                } else {

                    //
                    $this.append($('<label class="radio"></label>').addClass(className).prepend(oldInput));

                }

            });

        }

        this.$labels = $('.checkbox, .radio').closest('label');

        this.$labels.on('click', () => {
            this.toggleLabel();
        });

        this.toggleLabel();

        let $validationMessage = $('.validation_message');

        $validationMessage.each(function () {

            let $this = $(this);
            let validateMessage = $this.html();

            if (validateMessage === '') {
                $this.remove();
            }

        });

        $('.gform_button').addClass('green with-icon icon-right arrow-right');

        //  Fixes required field for complex fields
        let $complexLabel = $('.ginput_complex label');

        $complexLabel.each(function () {
            let originalLabelText = $(this).text();
            let newLabelText = originalLabelText.replace(' *', '<span class="gfield_required">*</span>');
            $(this).html(newLabelText);
        });

    }

}

module.exports = Form;
